import { useEffect, useState } from 'react'

import { OptionsHelper, showError } from '../../../../../../_metronic/helpers'
import { IOption } from '../../../../../components'
import { getTiposEndereco } from '../../../empresa/empresas-list/core/_requests'

/**
 * Carrega os tipos de endereço (Comercial, Atendimento, Prescrição) de uma vez só, em vez de
 * usar `OptionsHelper.getOptionsTiposEnderecos` no `fetchOptions` do select: são poucos
 * registros e a lista também é necessária fora do select, para reconstruir a opção do endereço
 * já cadastrado — a projeção `EnderecoList` do backend devolve apenas a descrição do tipo
 * (`tipoEndereco`), sem o id que o formulário precisa enviar.
 */
export const useOptionsTiposEndereco = () => {
  const [options, setOptions] = useState<IOption<number>[]>([])

  useEffect(() => {
    const carregarTipos = async () => {
      try {
        const tipos = await getTiposEndereco()
        setOptions(OptionsHelper.createOptions<number>(tipos, 'descricao', 'id'))
      } catch (error) {
        showError(error)
      }
    }

    carregarTipos()
  }, [])

  return options
}

export const findTipoEnderecoPorDescricao = (
  options: IOption<number>[],
  descricao?: string
): IOption<number> | undefined =>
  descricao ? options.find((option) => option.label === descricao) : undefined
